import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import { useThemeContext } from "../../context/ThemeContext";

const CustomInput = ({ label, name, value, onChange, type = "text", fullWidth = true }) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === "dark";

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <TextField
        fullWidth={fullWidth}
        label={label}
        name={name}
        value={value || ""}
        onChange={onChange}
        type={type}
        sx={{
          width: '250px',
          mb: 2,
          "& .MuiInputBase-input": { color: isDarkMode ? "#fff" : "#000" },
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderColor: "#ddd",
            backgroundColor: isDarkMode ? "#333" : "#fff",
            "&:hover fieldset": { borderColor: "#4CAF50" },
            "&.Mui-focused fieldset": { borderColor: "#4CAF50", borderWidth: "2px" },
          },
          "& .MuiInputLabel-root": { color: isDarkMode ? "#bbb" : "#666" },
          "& .MuiInputLabel-root.Mui-focused": { color: "#4CAF50" },
        }}
        InputProps={type === "number" ? { startAdornment: <InputAdornment position="start">$</InputAdornment> } : {}}
      />
    </Box>
  );
};

export default CustomInput;
